import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { KilavuzlarComponent } from './kilavuzlar/kilavuzlar.component';
import { AuthGuard, PermissionGuard, HomeRedirectGuard } from '@anadolu-commons/tohum-ui';
import { OdemeBasariliComponent } from './odeme-basarili/odeme-basarili.component';
import { OdemeHataliComponent } from './odeme-hatali/odeme-hatali.component';
import { EPostaDogrulamaComponent } from './e-posta-dogrulama/e-posta-dogrulama.component';
import { AnaSayfaComponent } from './ana-sayfa/ana-sayfa.component';
import { EDevletGirisGerekliComponent } from './e-devlet-giris-gerekli/e-devlet-giris-gerekli.component';
import { MasterPageComponent } from './master-page/master-page.component';
import { GirisComponent } from './giris/giris.component';


export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login-routes').then(m => m.loginRoutes)
  },
  {
    path: 'giris',
    data: { title: 'Giriş' },
    component: GirisComponent,
  },
  {
    path: '',
    data: { title: '' },
    component: AnaSayfaComponent
  },
  {
    path: 'anasayfa',
    data: { title: '' },
    component: AnaSayfaComponent
  },
  {
    path: '',
    data: { title: 'menu.anasayfa', canActivateChild: [AuthGuard] },
    component: MasterPageComponent,
    children: [
      {
        path: 'aday', data: { title: null }, canActivateChild: [AuthGuard], loadChildren: () => import('./aday-islemleri/aday-islemleri-routes')
          .then(m => m.AdayIslemleriRoutes)
      },
      {
        path: 'e-devlet-girisi-gerekli',
        data: { title: '' },
        canActivate: [AuthGuard],
        component: EDevletGirisGerekliComponent
      },
      {
        path: 'kilavuzlar',
        data: { title: '' },
        component: KilavuzlarComponent
      },
      {
        path: 'odeme-basarili/:id',
        component: OdemeBasariliComponent
      },
      {
        path: 'odeme-hatali',
        component: OdemeHataliComponent
      },
      {
        path: 'e-posta-dogrulama/:basvuruTuru/basvuruId/:ePosta/:onayKodu',
        data: { title: null },
        component: EPostaDogrulamaComponent
      }
    ]
  }
];


